import { render } from "./Invite.vue?vue&type=template&id=e36ba606&scoped=true"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"

import "./Invite.vue?vue&type=style&index=0&id=e36ba606&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e36ba606"]])

export default __exports__